import { httpservice } from '../services';
import { constants } from '../constant/constant';

const doManageSMSForUser = (isEnabled) => httpservice()
  .post(isEnabled ? constants.API.ENABLE_SMS : constants.API.DISABLE_SMS)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export default doManageSMSForUser;
